module.exports = __webpack_public_path__ + "img/amex.686afd7c.svg";